import '../../App.css';
import React from 'react';
import Footer from '../Footer';
import Header from './Header';
import Summary from './Summary';

function Resume() {
  return (
    <>
    <Header />
    <Summary />
    <Footer />
    </>
  );
}

export default Resume;